import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlugCircleCheck, faRestroom, faTint, faWarehouse, faWifi,} from "@fortawesome/free-solid-svg-icons";
import { faBuilding } from "@fortawesome/free-regular-svg-icons";
import { useState } from "react";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { useEffect } from "react";
import { Button } from "primereact/button";
import FichaTecnicaModal from '../components/FichaTecnicaModal';


const ProductosDisponiblesTable = ({
  productosDisponibles,
  loading2,
  rowClick,
  carro,
  setCarro,
  desdeFiltro,
  hastaFiltro,
  setDisplayDialog,
  nombreEmpresa,
}) => {

  const [showFichaModal, setShowFichaModal] = useState(false);
  const [selectedProductoFicha, setSelectedProductoFicha] = useState(null);
  
  // Funciones para manejar el modal de ficha técnica
  const openFichaModal = (producto) => {
      setSelectedProductoFicha(producto);
      setShowFichaModal(true);
  };

  const closeFichaModal = () => {
      setShowFichaModal(false);
      setSelectedProductoFicha(null);
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);

  useEffect(() => {
    initFilters();
  }, []);

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      metraje_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
        <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={(e) => onGlobalFilterChange(e)}
            placeholder="Buscar por Descripción"
          />
        </span>
        <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
          <Button
            raised
            onClick={() => setDisplayDialog(true)}
            outlined
            className="ml-2 text-blue-600 text-sm hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded transition"
          >
            ¿No encuentras el producto que buscas? Solicítalo en lista de espera.
          </Button>
        </span>
      </div>
    );
  };
  const header = renderHeader();

  return (
    <>
      <DataTable
        value={productosDisponibles}
        className="p-datatable-gridlines"
        showGridlines
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        dataKey="id"
        loading={loading2}
        emptyMessage="No se encontraron productos disponibles."
        stripedRows="true"
        selectionMode={rowClick ? null : "checkbox"}
        selection={carro}
        onSelectionChange={(e) => setCarro(e.value)}
        id="productosDataTable"
        paginator
        globalFilterFields={["nombre_producto", "metraje_producto"]}
        filters={filters}
        scrollHeight="57vh"
        scrollable
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"   
        currentPageReportTemplate={`Mostrando {first} a {last} de {totalRecords} productos de ${nombreEmpresa}`}
        header={header}
        reorderableColumns
        resizableColumns
        columnResizeMode="fit"
        >
        <Column
          selectionMode="multiple"
        />
        <Column
          field="nombre_producto"
          style={{ width: "11%" }}
          header="Descripción"
          filter
          body={(rowData) => (
            <div style={{display: "flex", alignItems: "center",}}>

              <span style={{ textTransform: "uppercase" }}>
                {rowData.nombre_producto}
              </span>
              
            </div>
          )}
          sortable
        />
        <Column
            field="es_union"
            header="Estados"
            body={(rowData) => (
            <>
                <div>
                  {rowData.es_union ? (
                    <Button
                        icon="pi pi-link"
                        className="p-button-rounded p-button-secondary p-button mr-2 mb-2 mt-2"
                        outlined
                        tooltip="Producto Combinado"
                        tooltipOptions={{ position: 'top' }}
                    />
                    ) : ( 
                    <Button
                        icon="pi pi-check"
                        className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                        outlined
                        tooltip="Producto Disponible"
                        tooltipOptions={{ position: 'top' }}
                    />
                  )}

                </div>
            </>
            )}
            sortable
        />
        <Column 
          field="tipo_producto" 
          header="Tipo"  
          sortable
        />
        <Column 
          field="empresa" 
          header="Empresa"  
          sortable
        />
        <Column
          field="metraje_producto"
          filterField="metraje_producto"
          header="Metraje"
          filter
          filterPlaceholder="Buscar por metraje"
          body={(rowData) => (
            <div style={{ display: "flex", alignItems: "center", }}>
              <span>{rowData.metraje_producto}</span>
              <span style={{ marginLeft: "4px" }}>{rowData.unidad === "m**2" ? "m²" : rowData.unidad}</span>
            </div>
          )}
          sortable
        />
        <Column
          body={(rowData) =>
            desdeFiltro
              ? new Date(desdeFiltro).toLocaleDateString("en-GB", {
                  timeZone: "UTC",
                })
              : ""
          }
          header="Desde"
        />
        <Column
          body={(rowData) =>
            hastaFiltro
              ? new Date(hastaFiltro).toLocaleDateString("en-GB", {
                  timeZone: "UTC",
                })
              : ""
          }
          header="Hasta"
        />
        <Column
          header="Servicios"
          body={(rowData) => (
            <span>
              {rowData.oficina ? (
                <FontAwesomeIcon
                  icon={faBuilding}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Oficina"
                  tooltip={`Producto con Oficina`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
              {rowData.bano ? (
                <FontAwesomeIcon
                  icon={faRestroom}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Baño"
                  tooltip={`Producto con Baño`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
              {rowData.modulo ? (
                <FontAwesomeIcon
                  icon={faWarehouse}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Módulo"
                  tooltip={`Producto con Módulo`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}

              {rowData.agua ? (
                <FontAwesomeIcon
                  icon={faTint}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Agua"
                  tooltip={`Producto con Agua`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
              {rowData.electricidad ? (
                <FontAwesomeIcon
                  icon={faPlugCircleCheck}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Electricidad"
                  tooltip={`Producto con Electricidad`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
              {rowData.internet ? (
                <FontAwesomeIcon
                  icon={faWifi}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Internet"
                  tooltip={`Producto con Internet`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
              {rowData.subproducto ? (
                <FontAwesomeIcon
                  icon={faWarehouse}
                  style={{ color: "#0150a0" }}
                  size="2xl"
                  className="ml-2 mr-2 mb-1 mt-1 "
                  title="Subproducto"
                  tooltip={`Producto con Subproducto`}
                  tooltipOptions={{ position: 'top' }}
                />
              ) : (
                <></>
              )}
            </span>
          )}
        />
        <Column
            header="Acciones"
            body={(rowData) => (
              <span>
                  <Button
                      icon="pi pi-file-o"
                      className="p-button-rounded p-button-info p-button-outlined p-button mr-2 mb-2 mt-2"
                      tooltip="Ver Ficha Técnica"
                      label="Ficha"
                      onClick={() => openFichaModal(rowData)}
                  />
              </span>
            )}
        />
      </DataTable>

      <FichaTecnicaModal
          visible={showFichaModal}
          onHide={closeFichaModal}
          productoId={selectedProductoFicha?.id}
          productoDescripcion={selectedProductoFicha?.descripcion}
      />

      
    </>
  );
};

export default ProductosDisponiblesTable;
